export default "__VITE_ASSET__F7CL0mwm__"